import nls from './nls/PayrollReviewDi';
import { createTranslator } from '~/lib/nls-helper';

export const NLS = createTranslator(nls);

export const setPageTitle = (title) => {
  document.title = title;
};

export const getHeaderKey = (offerId) => {
  if (['LC_Recom_Rev_Premier_BPI', 'Refill_Nom_Mob'].includes(offerId))
    return 'HSBC Payroll Loan';
  else if (['LC_Recom_Rev_Adva_BPI', 'Sub_Rev_OH', 'Refill_CP_Mob'].includes(offerId))
    return 'HSBC Personal Loan';
  else {
    return 'HSBC Personal Loan or HSBC Payroll Loan';
  }
};
